import { ERROR } from 'libs/shared/utils/src/constants/ReactQueryAPIConstants';
import { getAPIErrorResponse } from 'libs/shared/utils/src/utils/ApiErrorUtils';
import { useQuery } from 'react-query';

import { Config } from '@nw/shared/config';

export const useQueryClientWebinarProductConfigHook = (productCode) => {
  const fetchWebinarProductConfigData = async (productCode) => {
    return await fetch(
      `https://nw-payments-backend-media-static.s3.ap-south-1.amazonaws.com/${Config['ENVIRONMENT']}/product_configs/${productCode}.json`
    ).then((res) => res.json());
  };

  const { data, status, error } = useQuery(['productCode', productCode], () =>
    fetchWebinarProductConfigData(productCode)
  );

  return {
    data,
    status,
    error: status === ERROR ? getAPIErrorResponse(error) : ''
  };
};
